module.exports = __webpack_public_path__ + "65702a37d0b92f41fe8278d960436174.png";